export default "__VITE_ASSET__9341d6dd__"